import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Modal,
  Button,
  Stack,
  TextField,
  Checkbox,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper
} from '@mui/material';
import { updateGenericData } from './api';
import { cores, labelCampoEscuro } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '95vh',
  '@media screen and (max-width: 600px)': {
    width: '90vw',
    height: '95vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center',
};

const ModalAddOperadora = React.forwardRef((props, ref) => {
  const [data, setData] = useState(props.dataSelected || {});

  // Atualiza a quantidade de parcelas ao mudar o campo
  const handleChange = (e) => {
    const { id, value } = e.target;
    const updated = { ...data, [id]: id === 'quantidadeParcelas' ? parseInt(value || 0, 10) : value };
    setData(updated);
  };

  // Garante que taxasAntecipacao tenha o tamanho correto baseado em quantidadeParcelas
  useEffect(() => {
    const qtd = parseInt(data.quantidadeParcelas || 0, 10);
    if (qtd > 0) {
      const newTaxas = [...(data.taxasAntecipacao || [])];
      while (newTaxas.length < qtd) newTaxas.push(0);
      if (newTaxas.length > qtd) newTaxas.length = qtd;
      setData({ ...data, taxasAntecipacao: newTaxas });
    }
  }, [data.quantidadeParcelas]);

  const handleTaxaChange = (index, value) => {
    const taxas = [...data.taxasAntecipacao];
    taxas[index] = parseFloat(value) || 0;
    setData({ ...data, taxasAntecipacao: taxas });
  };

  const saveData = async () => {
    await updateGenericData('operadora', data);
    props.onConfirm();
  };

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box sx={style} gap={2}>
        <TextField
          id="nome"
          label="Nome"
          variant="outlined"
          value={data?.nome}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />
        <TextField
          type="number"
          id="quantidadeParcelas"
          label="Parcelamento Disponível"
          variant="outlined"
          value={data?.quantidadeParcelas}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />
        <TextField
          type="number"
          id="txCreditoAVista"
          label="Taxa Crédito À Vista (%)"
          variant="outlined"
          value={data?.txCreditoAVista}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />
        <TextField
          type="number"
          id="txCreditoParcelado"
          label="Taxa Crédito Parcelado (sem antecipação) (%)"
          variant="outlined"
          value={data?.txCreditoParcelado}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />

        {data.quantidadeParcelas > 0 && (
          <Box sx={{ width: '70%', maxHeight: '500px', overflowY: 'auto', mt: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ color: cores.textoClaro }}>
              Taxas Crédito Antecipado (%)
            </Typography>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableBody>
                  {data.taxasAntecipacao?.map((taxa, index) => (
                    <TableRow key={index}>
                      <TableCell width="50%">Parcela {index + 1}</TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          value={taxa}
                          onChange={(e) => handleTaxaChange(index, e.target.value)}
                          size="small"
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        <Stack direction={'row'}>
          <Checkbox
            checked={data?.ativo}
            onChange={() => setData({ ...data, ativo: !data.ativo })}
            sx={{ color: 'rgba(255,255,255,0.7)', '&.Mui-checked': { color: cores.laranja } }}
          />
          <Typography mt={1} sx={{ color: cores.textoClaro }}>Ativo</Typography>
        </Stack>

        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={0}>
          <Button variant="outlined" onClick={props.onClose} color="error">
            Cancelar
          </Button>
          <Button variant="contained" color="success" onClick={saveData}>
            Salvar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

ModalAddOperadora.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  dataSelected: PropTypes.object,
};

export default ModalAddOperadora;